/**
 * Reusable section header used across the public site.
 *
 *   eyebrow    short uppercase label
 *   title      h2 text — supports <em> for italic accent (use rawTitle prop)
 *   lede       optional supporting paragraph
 *   align      'left' | 'center'  (defaults to left)
 *   action     optional ReactNode rendered to the right (link / button)
 */
export function SectionHead({ eyebrow, title, rawTitle, lede, align = 'left', action }) {
  const alignClass = align === 'center' ? ' section-head--center' : '';
  return (
    <div className={`section-head${alignClass}`}
      style={action ? { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 24, flexWrap: 'wrap' } : undefined}>
      <div>
        {eyebrow && <div className="section-eyebrow">{eyebrow}</div>}
        {rawTitle ? (
          <h2 className="section-title" dangerouslySetInnerHTML={{ __html: rawTitle }} />
        ) : (
          <h2 className="section-title">{title}</h2>
        )}
        {lede && <p className="section-lede">{lede}</p>}
      </div>
      {action && <div className="section-action">{action}</div>}
    </div>
  );
}
